import * as React from 'react';

import {useMutation} from '@apollo/react-hooks';

import {EmailTemplate} from 'nutshell-core/settings-constants';

import {Button} from 'shells/button/button';

import type {
    DripSequenceFragment as DripSequence,
    EditionFragment as DripEdition,
    DripSequenceActivate as DripSequenceActivateMutation,
    DripSequenceActivateVariables as DripSequenceActivateMutationVariables,
} from 'nutshell-graphql-types';

import {GetSessionUser} from '../../../core/get-session-user';
import {Setting} from '../../../core/setting';

import {ActivateDripSequenceModal} from './activate-sequence-modal/activate-drip-sequence-modal';
import DRIP_SEQUENCE_ACTIVATE from './graphql/mutations/drip-sequence-activate.graphql';

type Props = {
    buttonText: string;
    disabled: boolean;
    editions: DripEdition[];
    dripSequence: DripSequence;
    onActivated: () => void;
};

export function ActivateSequenceButton(props: Props) {
    const [isActivatingSequence, setIsActivatingSequence] = React.useState<boolean>(false);

    const [activateDripSequence] = useMutation<
        DripSequenceActivateMutation,
        DripSequenceActivateMutationVariables
    >(DRIP_SEQUENCE_ACTIVATE);

    return (
        <>
            <Button
                disabled={props.disabled}
                variant='primary'
                size='big'
                onClick={() => {
                    setIsActivatingSequence(true);
                }}
            >
                {props.buttonText}
            </Button>
            {isActivatingSequence ? (
                <GetSessionUser>
                    {({user}) => (
                        <Setting settingName={EmailTemplate.STREET_ADDRESS_SETTING_NAME}>
                            {({setting, isLoading}) => (
                                <ActivateDripSequenceModal
                                    isOpen={isActivatingSequence}
                                    onCloseModal={() => setIsActivatingSequence(false)}
                                    onConfirmActivate={() => {
                                        return activateDripSequence({
                                            variables: {
                                                input: {
                                                    dripSequenceId: props.dripSequence.id,
                                                },
                                            },
                                        }).then(() => {
                                            props.onActivated();
                                            setIsActivatingSequence(false);
                                        });
                                    }}
                                    editions={props.editions}
                                    dripSequence={props.dripSequence}
                                    streetAddress={setting ? setting.value : ''}
                                    canAccessSetup={Boolean(
                                        user && user.permissions.canAccessSetup
                                    )}
                                    isLoading={isLoading}
                                    scrollToEdition={(editionId: string) => {
                                        const edition = document.getElementById(editionId);
                                        if (edition) {
                                            edition.scrollIntoView();
                                        }
                                    }}
                                />
                            )}
                        </Setting>
                    )}
                </GetSessionUser>
            ) : undefined}
        </>
    );
}
